import arcalab_logo from '../images/arcalab_logo_branca.png'
import { useState, useEffect, useRef } from 'react';
import { PlaylistVideo } from './PlaylistVideo';
import { CreateAccount } from './CreateAccount';
import {Route, Routes, useNavigate} from 'react-router-dom'
import { LoginComponent } from './Login';
import Layout from './utils/Layout'
import RequireAuth from './utils/RequireAuth';
// import useAuth from './hooks/useAuth';
import { useAuth } from './context/AuthProvider';
import { Menu } from './Menu'
import { MainPage } from './MainPage';
import { ArcalabInscricao } from './inscricao/ArcalabInscricao';
import { ForgotPassComponent } from './ForgotPassword';
// import useRefreshToken from './hooks/useRefreshToken';
import { Panel } from './Panel';
import { FormProvider } from './context/FormProvider';
import { LabFormProvider } from './context/LabFormProvider';
import { useIsMobile } from './context/MobileContext';

export function Arcalab(props:any){

    const navigate = useNavigate()
    // const refresh = useRefreshToken()
    const {auth}:any = useAuth()
    // const [firstRender, setFirstRender] = useState(true)

    const isMobile = useIsMobile()

    useEffect(()=>{
        if(props.verifyMail){
            navigate('/account')
        }
    },[props.verifyMail])

    useEffect(()=>{
        if(props.forgotPass){
            navigate('/forgot')
        }
    },[props.forgotPass])

    // useEffect(()=>{
        // if(firstRender&&!auth?.email){
        //     refresh()
        // }
        // setFirstRender(false)
    // },[])

    return(
        <div>
            <Menu/>
            <div style={{width:isMobile?'80vw':'85vw',margin:'5vh auto'}}>
                    <div style={{marginBottom:'5vh'}}>
                        <img src={arcalab_logo} width={isMobile ? '180px' : '300px'} style={{cursor:'pointer'}} onClick={(()=>{navigate('/')})}/>
                    </div>
                <Routes>
                    <Route path='/' element={<Layout/>}>
                        {/* <Route path='/' element={<MainPage width={props.width}/>}/> */}
                        <Route path='/' element={<LabFormProvider><ArcalabInscricao width={props.width} cupom={props.cupom}/></LabFormProvider>}/>
                        <Route path='/account' element={<CreateAccount width={props.width} verifyMail={props.verifyMail}/>}/>
                        <Route path='/login' element={<LoginComponent/>}/>
                        <Route path='/forgot' element={<ForgotPassComponent width={props.width} forgotPass={props.forgotPass}/>}/>
                        <Route element={<RequireAuth/>}>
                            <Route path='/videos' element={<PlaylistVideo width={props.width}/>}/>
                            <Route path='/panel' element={auth?.roles?.includes(10)?<FormProvider><Panel width={props.width}/></FormProvider>:<PlaylistVideo width={props.width}/>}/>
                        </Route>
                    </Route>
                </Routes>
                
            </div>
        </div>
    )
}